var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"border-b--1px border--solid border--gray border--lighten-2 p--30px pb--26px mb--50px"},[_c('h1',{staticClass:"font--28px lh--1"},[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }